<template>
  <div class="select-nomenklatura">
    <!-- Фильтры -->
    <div class="search-section">
      <div class="filters-row">
        <CustomInput 
          label="Поиск" 
          placeholder="Наименование, GUID, код..."
          :value="searchText"
          @change_input="onSearchInput"
          @clear_input="() => onSearchInput('')"
          :isSearch="true"
          class="search-input"
        />
        <CustomSelect 
          :options="kategoriyaOptions" 
          label="Категория"
          placeholder="Выберите..."
          option-label-key="label"
          option-value-key="value" 
          @change="onKategoriyaChange"
          :value="selectedKategoriya" 
          class="kategoriya-select"
        />
      </div>
    </div>

    <!-- Таблица номенклатуры -->
    <div class="table-section">
      <q-linear-progress v-if="loading" indeterminate />
      
      <div v-else-if="allNomenklatura.length === 0" class="empty-state">
        <q-icon name="inventory_2" size="64px" color="grey-5" />
        <div class="empty-text">Номенклатура не найдена</div>
      </div>

      <q-table
        v-else
        :rows="allNomenklatura"
        :columns="nomenklaturaColumns"
        row-key="ssylka__id"
        flat
        bordered
        dense
        :rows-per-page-options="[50, 100, 500]"
        :pagination="pagination"
        @update:pagination="pagination = $event"
        @row-click="(evt, row) => selectNomenklatura(row)"
        class="nomenklatura-table clickable-rows"
        virtual-scroll
        :virtual-scroll-item-size="36"
      >
        <template v-slot:body-cell-naimenovanie="props">
          <q-td :props="props">
            <div class="name-cell">
              {{ props.value }}
            </div>
            <div class="sub-info">
              <span class="guid-cell" v-if="props.row.ssylka__id">{{ props.row.ssylka__id }}</span>
              <span class="kod-cell" v-if="props.row.kod">{{ props.row.kod }}</span>
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-nomenklaturnaya_kategoriya__view="props">
          <q-td :props="props">
            <div class="name-cell">
              {{ props.value || '-' }}
            </div>
          </q-td>
        </template>

      </q-table>
    </div>
  </div>
</template>

<script>
import { getSbsNomenklaturaListForModal, getSbsNomenklaturaKategoriya } from "@/views/Materials/services";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "select-nomenklatura",
  components: { CustomSelect, CustomInput },
  props: ["data", "closeModal"],
  data() {
    return {
      loading: false,
      searchText: "",
      selectedKategoriya: null,
      kategoriyaOptions: [],
      allNomenklatura: [],
      searchTimeout: null,
      pagination: {
        rowsPerPage: 500
      },
      nomenklaturaColumns: [
        {
          name: 'naimenovanie',
          label: 'Наименование',
          field: 'naimenovanie',
          align: 'left',
          sortable: true,
          style: 'width: 65%;'
        },
        {
          name: 'nomenklaturnaya_kategoriya__view',
          label: 'Категория',
          field: 'nomenklaturnaya_kategoriya__view',
          align: 'left',
          sortable: true,
          style: 'width: 35%;'
        }
      ],
    };
  },
  computed: {},
  async mounted() {
    this.restoreFilters();
    await this.loadKategoriya();
    await this.loadNomenklatura(this.searchText, this.selectedKategoriya);
  },
  methods: {
    saveFilters() {
      localStorage.setItem('nomenklatura_filters', JSON.stringify({
        searchText: this.searchText,
        selectedKategoriya: this.selectedKategoriya
      }));
    },
    restoreFilters() {
      try {
        const saved = localStorage.getItem('nomenklatura_filters');
        if (saved) {
          const filters = JSON.parse(saved);
          this.searchText = filters.searchText || "";
          this.selectedKategoriya = filters.selectedKategoriya || null;
        }
      } catch (e) {
        console.error('Error restoring filters:', e);
      }
    },
    onSearchInput(value) {
      this.searchText = value;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.saveFilters();
        this.loadNomenklatura(value || "", this.selectedKategoriya);
      }, 400);
    },
    onKategoriyaChange(value) {
      this.selectedKategoriya = value;
      this.saveFilters();
      this.loadNomenklatura(this.searchText || "", value);
    },
    async loadKategoriya() {
      const res = await getSbsNomenklaturaKategoriya();
      this.kategoriyaOptions = (res || []).map(item => ({
        label: item.nomenklaturnaya_kategoriya__view,
        value: item.nomenklaturnaya_kategoriya__view
      }));
    },
    async loadNomenklatura(search_text = "", kategoriya = null) {
      this.loading = true;
      const res = await getSbsNomenklaturaListForModal(search_text, kategoriya);
      this.allNomenklatura = res || [];
      this.loading = false;
    },
    selectNomenklatura(item) {
      if (this.data?.onSelect) {
        this.data.onSelect(item);
      }
      this.$nextTick(() => {
        if (this.closeModal) {
          this.closeModal();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.select-nomenklatura {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: white;
  overflow: hidden;
}

.search-section {
  flex-shrink: 0;
}

.filters-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.search-input {
  flex: 1;
}

.kategoriya-select {
  min-width: 220px;
}

.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #999;
  flex: 1;
  min-height: 200px;
}

.empty-text {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

.nomenklatura-table {
  flex: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  :deep(.q-table__container) {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }

  :deep(.q-table__top),
  :deep(.q-table__bottom) {
    flex-shrink: 0;
  }

  :deep(.q-table__middle) {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  :deep(thead tr th) {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
    font-weight: 600;
    font-size: 13px;
    padding: 8px 12px;
  }

  :deep(tbody tr) {
    cursor: pointer;
    transition: background-color 0.15s;
    
    &:hover {
      background-color: #e3f2fd;
    }
  }

  :deep(tbody td) {
    font-size: 13px;
    padding: 6px 12px;
    vertical-align: top;
  }
}

.name-cell {
  word-break: break-word;
  white-space: normal;
  line-height: 1.4;
  font-weight: 500;
}

.sub-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-top: 2px;
}

.guid-cell {
  font-family: 'Courier New', monospace;
  font-size: 10px;
  color: #1976d2;
  word-break: break-all;
}

.kod-cell {
  font-family: 'Courier New', monospace;
  font-size: 10px;
  color: #666;
}
</style>

